
export class StatoSegnalazione {
    id: Number;
    label: String;
    descrizione: String;
  }
